// Personal libs
import { apiPost } from './common/api';
import endpoints from 'src/shared/service/endpoint/endpoints.class';
import { IApiResponse } from '@shared/interface/api-response.interface';
import { ApiError } from '@shared/error/api.error';
import { manageApiError } from './common/api.lib';

//******************************************************************************** POST
/**
 * Signup
 * @returns
 */
export interface IApiPostSignup {
  username: string;
  email: string;
  password: string;
  passwordConfirm: string;
  chkAcceptRules: boolean;
  csrf?: string;
}
export const apiPostSignup = (
  params: IApiPostSignup,
): Promise<IApiResponse<string>> => {
  const payload: IApiPostSignup = {
    username: params.username,
    email: params.email,
    password: params.password,
    passwordConfirm: params.passwordConfirm,
    chkAcceptRules: params.chkAcceptRules,
    csrf: params.csrf,
  };

  const endpointClass = endpoints.signup.postSignup;
  return apiPost(endpointClass.getUrl(), payload, {
    publicApi: endpointClass.isPublic(),
  })
    .then((response: IApiResponse<string>) => {
      if (response.returnCode !== 'SIGNUP_OK') {
        throw new ApiError(
          response?.returnError ?? '',
          response.returnCode,
          response.rateLimit,
        );
      } else {
        return response;
      }
    })
    .catch((error: ErrorConstructor) => manageApiError(error, 'apiPostSignup'));
};

/**
 * Signup accept
 * @returns
 */
export interface IApiPostSignupAccept {
  uuid: string;
}
export const apiPostSignupAccept = (
  params: IApiPostSignupAccept,
): Promise<IApiResponse<string>> => {
  const endpointClass = endpoints.signup.postSignupAccept;
  return apiPost(endpointClass.getUrl(), params, {
    publicApi: endpointClass.isPublic(),
  })
    .then((response: IApiResponse<string>) => {
      if (
        response.returnCode !== 'SIGNUP_ACCEPT_OK' &&
        response.returnCode !== 'SIGNUP_ACCEPT_OK_NO_MAIL'
      ) {
        throw new ApiError(
          response?.returnError ?? '',
          response.returnCode,
          response.rateLimit,
        );
      } else {
        return response;
      }
    })
    .catch((error: ErrorConstructor) =>
      manageApiError(error, 'apiPostSignupAccept'),
    );
};

/**
 * Signup accept
 * @returns
 */
export interface IApiPostSignupReject {
  uuid: string;
}
export const apiPostSignupReject = (
  params: IApiPostSignupReject,
): Promise<IApiResponse<string>> => {
  const endpointClass = endpoints.signup.postSignupReject;
  return apiPost(endpointClass.getUrl(), params, {
    publicApi: endpointClass.isPublic(),
  })
    .then((response: IApiResponse<string>) => {
      if (
        response.returnCode !== 'SIGNUP_REJECT_OK' &&
        response.returnCode !== 'SIGNUP_REJECT_OK_NO_MAIL'
      ) {
        throw new ApiError(
          response?.returnError ?? '',
          response.returnCode,
          response.rateLimit,
        );
      } else {
        return response;
      }
    })
    .catch((error: ErrorConstructor) =>
      manageApiError(error, 'apiPostSignupReject'),
    );
};
